import { IStoreState } from "../types";

export const isSidemenuOpen = (state: IStoreState) =>
    state.settings.showSidebar;

export const sidemenuHoverState = (state: IStoreState) =>
    state.settings.sidebarHoverState;
